import React, { useState, Fragment } from 'react'
import { Segment, Button, Icon, Loader, Divider } from 'semantic-ui-react'
import { getAuthor } from './utils'

const StoryStartScreen = (props) => {
  const {
    story,
    soundsLoaded,
    soundsProgress,
    onStart,
    onShowCredits,
    onClose,
    canClose
  } = props
  const [activeSounds, setActiveSounds] = useState(true)
  const hasSounds = story.sounds && Object.keys(story.sounds).length > 0

  const isLoaded = soundsLoaded || !hasSounds

  return (
    <Segment inverted padded='very' style={{ width: 350}}>
      { story ? (
        <Fragment>
          <div style={{ fontStyle: 'italic' }}>Moiki présente</div>
          <h2 style={{ marginBottom: '0.3em' }}>{ story.meta.name }</h2>
          <div style={{ fontStyle: 'italic', color: '#9e9a9a', marginBottom: '1em' }}>Une histoire de { getAuthor(story.meta) }</div>
          <div style={{ height: '5em', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {(isLoaded || !activeSounds) ? (
              <Button onClick={() => onStart({sounds: activeSounds})} primary icon='play' circular size='huge' style={{ margin: '.75em' }} />
            ) : (
              <Segment inverted style={{ margin: '1.8em' }}>
                <div>téléchargement des sons<br/>{ soundsProgress.toFixed(0) }%</div>
                <div style={{ width: '100%', height: 4, position: 'relative', background: '#666', display: 'block', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: soundsProgress + '%', background: '#2185D0', display: 'block'  }} />
                </div>
              </Segment>
            )}
          </div>
          { hasSounds && (
            <Fragment>
              <Divider inverted horizontal>Options</Divider>
              <div>Cette aventure possède une ambiance sonore</div>
              <Button circular basic inverted onClick={() => setActiveSounds(!activeSounds)} style={{ marginTop: '1em', width: 160 }}>
                <Icon name={activeSounds ? 'volume up' : 'volume off'} /> sons {activeSounds ? 'activés' : 'désactivés'}
              </Button>
            </Fragment>
          )}
          <Divider inverted />
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button className='link-button' basic inverted size='mini' onClick={onShowCredits}>voir les crédits</Button>
          </div>
         </Fragment>
      ) : (
        <Loader active={true} />
      )}
    </Segment>
  )
}

export default StoryStartScreen